// src/components/atoms/Card.ts
import styled from "styled-components";

type CardProps = {
  $margin?: string;   // transient prop (won't be forwarded to DOM)
  $padding?: string;
};

const Card = styled.div<CardProps>`
  background: white;
  margin: ${({ $margin }) => $margin ?? "30px 20px"};
  padding: ${({ $padding }) => $padding ?? "5px 10px"};
  border-radius: 22px;
  box-shadow: 2px 2px 4px 4px rgba(0, 0, 0, 0.1);
`;

export default Card;
